import React, {
  Fragment,
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
  useContext,
  useCallback,
} from "react";

import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _U } from "../../../../modules/utils";

import axios from 'axios';

//HLS
import { _CFG } from "../../../../modules/config";

import ReactJWPlayerContainer from "./JWPlayer";
// import ReactJWPlayerContainerTypeB from "./jwplayerType-B";
import moment from "moment";
import useStore from "../../../../modules/utils/store";
import playerUnmountUtils from "../../../../modules/utils/playerUnmount";
import { parseVideoTimeSeconds, resolveOndemandPlaybackSource } from "../../ondemandPlayback";
import { buildLiveStreamUrl, buildLiveBackupUrl } from "../../livePlayback";


export default (props) => {
  const { shouldReloadOnPlayerUnmount } = playerUnmountUtils;
  const { iam } = useContext(AppContext);
  const { siteInfo } = useStore();
  const { consoleCfg, player, setPlayer, clickVideoTime, surveyInfo, setSurveyInfo, state} = props;
  
  const preregIdx = iam?.preregIdx;
  const [waitInterval, setWaitInterval] = useState();
  const {playerSetting, setPlayerSetting} = useStore();
  
  const [delay, setDelay] = useState(1000 * 60);
  const [isRunning, setIsRunning] = useState(false);

  const [url, setUrl] = useState({});

  const [videoTime, setVideoTime] = useState({});

  const [status, setStatus] = useState("CONSOLE_IN");

  const [isStart, setIsStart] = useState(false);

  const [playerInstance, setPlayerInstance] = useState(null); // JWPlayer 인스턴스 저장
  const [forceStop, setForceStop] = useState(false); // STREAM_OFFLINE 수신 시 강제 중단
  const forceStopRef = useRef(false); // onErrorCallback 스테일 클로저 방지용 ref

  const autuPlayInterval= useRef();
  const prevEndPointRef = useRef(null);
  const lastOnlineChannelIdRef = useRef(undefined); // STREAM_ONLINE 수신 시 channelId 저장 (swap 판별용)
  const sessionIdxRef = useRef(consoleCfg?.sessionIdx); // 세션 필터링용 (다른 세션의 STREAM 이벤트 무시)

  const [playList, setPlayList] = useState(null);

  const pageInTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
  
  let pageOutTime = "";

  const logKey = _CK.getLogKey() || '';

  const _liveQueryStr = `?eventIdx=${consoleCfg.eventIdx}&sessionIdx=${consoleCfg.sessionIdx}&consoleIdx=${consoleCfg.consoleIdx}&email=${iam?.email || ''}&logKey=${logKey}`;
  // 유효한 스트림 URL이 없으면 즉시 에러 이미지 표시
  // ngrp:_all = 스트림 키가 비어있는 무효 URL (NCloud 채널 미연결 상태)
  const urlKeyUrlHasStreamKey = consoleCfg?.urlKeyUrl?.startsWith('http') &&
    !consoleCfg?.urlKeyUrl?.includes('/ngrp:_all');
  const hasValidUrl =
    consoleCfg?.consoleEndPoint?.startsWith('https') ||
    consoleCfg?.consoleHdServerIdx == 10 ||
    urlKeyUrlHasStreamKey ||
    (consoleCfg?.serviceType === 'ONDEMAND' && consoleCfg?.consoleVodIdx > 0);
  const primaryUrl = buildLiveStreamUrl(consoleCfg || {}, _liveQueryStr);

  const backupUrl = buildLiveBackupUrl(primaryUrl);

  const playlist_live = [
    {
      sources: [
        {
          file: primaryUrl,
          label: "Primary Stream",
        },
        {
          file: backupUrl,
          label: "Backup Stream",
        },
      ],
      image: consoleCfg?.signedUrlConsolePlayerImg || "",
      controls: true,
    },
  ];



  const settingPlayList = () => {
    if(consoleCfg?.serviceType === "ONDEMAND"){
      if (consoleCfg?.consoleVodIdx > 0) {
        const req = {
          path: "/v1/resource/media/info",
          data: {
            idx: consoleCfg?.consoleVodIdx,
          },
        };
        _API.post(req).then(async (res) => {
          const { data } = res.data;
          var total = parseVideoTimeSeconds(data.videoTime);
          const playbackSource = await resolveOndemandPlaybackSource(data, (outputId) => _API.post({
            path: `/v1/captions/media/transcode-outputs/${outputId}/preview-url`,
            data: {
              ttlSeconds: 60 * 60,
            },
            isNoErrorNotify: true,
          }));
          const playbackUrl = playbackSource.url;
          const playbackSourceType = playbackSource.sourceType;
          
          setVideoTime(total); //비디오 총 시간을 초단위로 설정 한 후 on_time event 발생시 저장
          setUrl(data);

          const playlist_onDemend = [
            {
              // file: `https://medinar-files-private-prod.s3.ap-northeast-2.amazonaws.com/2023/10/27/5a98bab0749211ee89917fe0a5276bf9.m3u8`,
              file: playbackUrl || "",
              sources: [
                {
                  file: playbackUrl || "",
                  type: playbackSourceType,
                },
              ],
              type: playbackSourceType,
              image: consoleCfg?.signedUrlConsolePlayerImg || "",
              controls: true,
            },
          ];
          setPlayList(playlist_onDemend)
        });
      }      
    }else if(consoleCfg?.serviceType === "LIVE"){
 /*      if(consoleCfg?.consoleConsoleType === "HD" || consoleCfg?.consoleConsoleType === "RTC_HD"){
        const playlist_live = [
          {
            file:
              consoleCfg?.consoleHdServerIdx == 10
                ? consoleCfg?.cfUrl +
                  consoleCfg?.consoleEndPoint +
                  "/index.m3u8" +
                  `?eventIdx=${consoleCfg.eventIdx}&sessionIdx=${consoleCfg.sessionIdx}&consoleIdx=${consoleCfg.consoleIdx}&email=${iam?.email || ''}&logKey=${logKey}`
                : (consoleCfg?.urlKeyUrl?.indexOf(window.location.protocol) != -1
                    ? consoleCfg?.urlKeyUrl +
                      `?eventIdx=${consoleCfg.eventIdx}&sessionIdx=${consoleCfg.sessionIdx}&consoleIdx=${consoleCfg.consoleIdx}&email=${iam?.email || ''}&logKey=${logKey}`
                    : consoleCfg?.urlKeyUrl.replace(
                        consoleCfg?.urlKeyUrl.slice(
                          0,
                          consoleCfg?.urlKeyUrl.indexOf(":") + 1
                        ),
                        window.location.protocol
                      )) +
                  `?eventIdx=${consoleCfg.eventIdx}&sessionIdx=${consoleCfg.sessionIdx}&consoleIdx=${consoleCfg.consoleIdx}&email=${iam?.email || ''}&logKey=${logKey}`,
            image: `${consoleCfg?.signedUrlConsolePlayerImg}`,
            controls: true,
          },
        ];
        setPlayList(playlist_live)
      } */
        setPlayList(playlist_live);
    }
    
  };
 
  const hlsConfig = {
    debug: _CFG.isLocal(),
    xhrSetup: (xhr, url) => {
      xhr.setRequestHeader("apikey", _CFG.apiKey);
      xhr.setRequestHeader("authorization", _CK.getAuth());
    },
    // startPosition : 3
  };

  const savePlaylog = ({ siteIdx, eventIdx, sessionIdx, consoleIdx, lastPlayTime, status, videoTime, eventTime }) => {
    const consoleCountView = _CK.getConsoleCountView();
    // Phase 2: 시청세션 ID (event,session 스코프). logKey·consoleCountView 는 그대로 유지(옵션1).
    const viewingSessionId = _CK.getViewingSessionId(consoleCfg?.eventIdx, consoleCfg?.sessionIdx) || '';

    // 🛡️ 필수 데이터 검증 (iam 로딩 완료 대기)
    if (!iam || !iam.preregIdx) {
      return; // 로그 전송하지 않음
    }

    var apiPath = "/v1/client/console/playlog/save";

    //onDemand 인경우
    if(consoleCfg?.serviceType === "ONDEMAND"){
      apiPath = "/v1/client/console/vodLog/save";
    }
    
    const req = {
      path: apiPath,
      isNoErrorNotify: true,
      data: {
        siteIdx,
        eventIdx,
        sessionIdx,
        consoleIdx,
        lastPlayTime,
        logKey,
        viewingSessionId,
        consoleCountView,
        pageInTime,
        pageOutTime,
        status,
        preregIdx: iam.preregIdx, // 🎯 검증된 preregIdx 사용
        videoTime,
        eventTime: eventTime || moment().format("YYYY-MM-DD HH:mm:ss"), // 정확한 이벤트 시간
      },
    };

    _API.post(req).then((res) => {
      let { data } = res;
      
      // 🔧 백엔드가 새로고침 감지 시 처리
      if (data && data.skipped === true) {
        if (data.logKey) {
          _CK.forceSetLogKey(data.logKey);
        }
        if (data.consoleCountView) {
          _CK.setConsoleCountView(data.consoleCountView);
        }
      }
    });
    
  };

  
  // const loadItem = async (idx) => {
  //   // VOD
  //   if (idx) {
  //     const req = {
  //       path: "/v1/resource/media/info",
  //       data: {
  //         idx: idx,
  //       },
  //     };
  //     await _API.post(req).then((res) => {
  //       const { data } = res.data;
  //       console.log("/media/info : ",data)
  //       var time = data.videoTime.split(':');
  //       var hour = time[0];
  //       var min = time[1];
  //       var sec = time[2];
  //       var total = (Number(hour) * 60 * 60) + (Number(min) * 60) + Number(sec)
        
  //       setVideoTime(total); //비디오 총 시간을 초단위로 설정 한 후 on_time event 발생시 저장
  //       setUrl(data);
  //     });
  //   }
  // };

  let videoInterval = null;
  const currentTimeRef = useRef(0); // useRef로 변경하여 렌더링 간 값 유지
  var actionName = "";

  // currentTime 업데이트 헬퍼 함수
  const updateCurrentTime = useCallback((value) => {
    currentTimeRef.current = value;
  }, []);

  const onPlayerDidMountCallback = useCallback(() => {
    const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
    saveLog("CONSOLE_IN", eventTime);
  });

  const onPlayerUnMountCallback = useCallback(() => {
    clearInterval(waitInterval);
    const exitTime = moment().format("YYYY-MM-DD HH:mm:ss");
    
    pageOutTime = exitTime;
    saveLog("CONSOLE_OUT", exitTime);

    setIsRunning(false);
    updateCurrentTime(0); // useRef 사용한 초기화
    if (shouldReloadOnPlayerUnmount(window.location.hostname)) {
      window.location.reload();
    }
  });

  var tmpTime = 0;
  const onTimeCallback = useCallback((event) => {
    const newTime = Math.floor(event.currentTime);
    updateCurrentTime(newTime); // useRef 사용한 업데이트
    if(consoleCfg?.serviceType === "ONDEMAND"){
      setStatus("ON_TIME");
      
      if(tmpTime != newTime){
        const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
        saveLog(status, eventTime);
      }
    
      tmpTime = newTime;
    }
  });
  
  const onCompleteCallback = useCallback((event) => {
    if(consoleCfg?.serviceType === "ONDEMAND"){
      const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
      setStatus("COMPLETE");
      saveLog("COMPLETE", eventTime);
      openSurvey(2)
    }
  });
  
  const openSurvey = (status) => {
    const req = {
      path: "/v1/event/session/surveys/find/menu/connect/survey",
      data : {
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        status : status,
      }
    };
    _API.post(req).then((res) => {
      if(res.data.data.idx > 0){
        const surveyData = {
          active : true,
          show : true,
          idx : res.data.data.idx
        }
        setSurveyInfo(surveyData)
      }else{
        if(status == 1){
          alert('현재 진행중인 서베이가 없습니다.');
        }
        return;
      }
    });
  }

  const showSurveyButton = consoleCfg?.consoleSurveyYn == 'Y' && surveyInfo?.active === true && Number(surveyInfo?.idx) > 0;

  // 콘솔 진입 시 사전서베이(BEFORE) 자동 노출 — status=0 분기로 BEFORE 타입 조회
  useEffect(() => {
    if (consoleCfg?.consoleSurveyYn == 'Y' && consoleCfg?.eventIdx && consoleCfg?.sessionIdx) {
      openSurvey(0);
    }
  }, [consoleCfg?.eventIdx, consoleCfg?.sessionIdx]);

  // 온디맨드: 영상 시청 전부터 사후 서베이(AFTER, status=2) 버튼 노출 위해 idx만 미리 로드.
  // show:false 로 세팅해 모달 자동 오픈은 막고, 사용자가 헤더 SURVEY 버튼 클릭 시 reopenActiveSurvey가 show:true 로 모달 오픈.
  useEffect(() => {
    if (consoleCfg?.serviceType !== 'ONDEMAND') return;
    if (consoleCfg?.consoleSurveyYn != 'Y') return;
    if (!consoleCfg?.eventIdx || !consoleCfg?.sessionIdx) return;

    const req = {
      path: "/v1/event/session/surveys/find/menu/connect/survey",
      data: {
        eventIdx: consoleCfg?.eventIdx,
        sessionIdx: consoleCfg?.sessionIdx,
        status: 2,
      },
    };
    _API.post(req).then((res) => {
      if (res?.data?.data?.idx > 0) {
        setSurveyInfo((prev) => ({
          ...(prev || {}),
          active: true,
          show: false,
          idx: res.data.data.idx,
        }));
      }
    });
  }, [consoleCfg?.serviceType, consoleCfg?.consoleSurveyYn, consoleCfg?.eventIdx, consoleCfg?.sessionIdx]);

  const handleCssFullscreenSurveyClick = useCallback(() => {
    setSurveyInfo((prev) => ({
      ...prev,
      show: true,
      clickStatus: "click",
    }));
  }, [setSurveyInfo]);

  const onPauseCallback = useCallback((event) => {
    const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
    //정지시시 로그 남기고 Pause
    setStatus("PAUSE");
    if(consoleCfg?.serviceType === "ONDEMAND"){
      saveLog("PAUSE", eventTime);
    }
    setIsRunning(false);
    setIsStart(false);
  });

  const onErrorCallback = useCallback((event) => {
    const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");

    //정지시시 로그 남기고 Pause
    setStatus("ERROR");

    if(consoleCfg?.serviceType === "ONDEMAND"){
      saveLog("ERROR", eventTime);
    }

    setIsRunning(false);

    // forceStop(테스트 송출 OFF 등)인 경우 재시도 루프 시작 안 함 (ref로 stale closure 방지)
    if (!forceStopRef.current) {
      setIsStart(true);
    }
  });

  
  const onResumeCallback = useCallback(async (event) => {
    const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
    // RESUME 이벤트에서도 현재 재생 시간 업데이트
    if (event && event.position !== undefined) {
      updateCurrentTime(Math.floor(event.position));
    }
    
    setStatus("RESUME");
    setIsStart(false);
    
    if(consoleCfg?.serviceType === "ONDEMAND"){
      saveLog("RESUME", eventTime);
    }

    if(consoleCfg?.serviceType === "LIVE" && (consoleCfg?.consoleConsoleType === "HD" || consoleCfg?.consoleConsoleType === "RTC_HD")){
      if (isRunning == false) {
        setIsRunning(true);
        setStatus("PLAY");
      }
    }

  });

  const onPlayCallback = useCallback((event) => {
    const eventTime = moment().format("YYYY-MM-DD HH:mm:ss");
    // PLAY 이벤트에서도 현재 재생 시간 업데이트
    if (event && event.position !== undefined) {
      updateCurrentTime(Math.floor(event.position));
    }
    
    setStatus("PLAY");
    setIsStart(false);

    if(consoleCfg?.serviceType === "ONDEMAND"){
      saveLog("PLAY", eventTime);
    }

    if(consoleCfg?.serviceType === "LIVE" && (consoleCfg?.consoleConsoleType === "HD" || consoleCfg?.consoleConsoleType === "RTC_HD")){
      setIsRunning(true);
    }
  });

  const onSeekCallback = useCallback(() => {
    setStatus("SEEK");
  });

  const onMetaCallback = useCallback((meta) => {
    

  });

  const onReadyCallback = useCallback((player) => {
    setPlayerInstance(player); // JWPlayer 인스턴스 저장
    setPlayer(player)
    setPlayerSetting(player)
  });

  useEffect(() => {
    if (status != "CONSOLE_IN") {
      saveLog(status);
    }
  }, [status]);

  useInterval(
    () => {
      saveLog(status);
    },
    isRunning ? delay : null
  );

  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  function saveLog(status, customEventTime = null) {
    const currentPlayTime = currentTimeRef.current; // useRef에서 값 가져오기
    const eventTime = customEventTime || moment().format("YYYY-MM-DD HH:mm:ss"); // 정확한 이벤트 시간
    
    // lastPlayTime이 0인 경우 필터링 (CONSOLE_IN, PLAY, SEEK 제외 - 이들은 시작점이므로 0이어도 기록)
    if (currentPlayTime === 0 && ['RESUME', 'PAUSE', 'ON_TIME'].includes(status)) {
      return;
    }

    savePlaylog({
      siteIdx: siteInfo.siteIdx,
      eventIdx: consoleCfg.eventIdx,
      sessionIdx: consoleCfg.sessionIdx,
      consoleIdx: consoleCfg.consoleIdx,
      lastPlayTime: currentPlayTime,
      status: status,
      videoTime: videoTime,
      eventTime: eventTime, // 정확한 이벤트 시간 전달
    });
  }

  useEffect(() => {

    if (isStart) {

      autuPlayInterval.current = setInterval(async () => {

        // forceStop(테스트 송출 OFF 등) 상태이면 재시도 스킵
        if (forceStopRef.current) return;

        // 재생 소스가 없으면(채널 미할당 등) 요청하지 않는다 - 시청자당 5초마다 무효 요청이 나간다
        if (!primaryUrl) return;

        try {

          // NCloud 미디어센터 URL(END_POINT에 https URL 저장)은 CORS로 인해 axios 직접 체크 불가, 바로 로드 시도
          if (consoleCfg?.consoleEndPoint?.startsWith('https')) {
            playerInstance?.load([{ file: primaryUrl }]);
            playerInstance?.play();
          } else {
            const response = await axios.get(primaryUrl);
            if (response.status === 200 && response.data.includes('#EXTM3U')) {
              playerInstance.load([{ file: primaryUrl }]);
              playerInstance.play();
            }
          }
        } catch (error) {
          // 스트리밍 불가 또는 중단 - 재시도 루프가 계속 실행됨
        }
      }, 5000);

    } else {
      clearInterval(autuPlayInterval.current);
      autuPlayInterval.current = null;
    }

    return () => {
      clearInterval(autuPlayInterval.current);
      autuPlayInterval.current = null;
    };
  }, [isStart, consoleCfg?.consoleEndPoint]);


  useEffect(() => {
    clearInterval(waitInterval);
    if(status == 'CONSOLE_IN' || status == 'PAUSE' || status == 'ERROR'|| status == 'COMPLETE'){
      setWaitInterval(() => {
        return setInterval(() => {
          saveLog('WAIT');
        },1000 * 60)
      })
    }
  },[status])

  useEffect(() => {
    setVideoTime(0);
  }, [consoleCfg]);

  useEffect(() => {
    const prevEndPoint = prevEndPointRef.current;
    const newEndPoint = consoleCfg?.consoleEndPoint;
    prevEndPointRef.current = newEndPoint;

    // 채널 재할당 중 null 전환 시 플레이어 상태 유지 (기존 스트림 계속 재생, 오류 방지)
    if ((newEndPoint === null || newEndPoint === undefined) && prevEndPoint?.startsWith('https')) {
      return;
    }

    if (newEndPoint?.startsWith('https') && playerInstance) {
      playerInstance.load([{ file: newEndPoint }]);
      playerInstance.play();
    } else {
      settingPlayList();
    }
    if(consoleCfg?.serviceType === "ONDEMAND" && (consoleCfg.videoTime == null || consoleCfg.videoTime == "")){
      $(".video_element").css("display","none")
    }
  }, [consoleCfg?.consoleEndPoint, consoleCfg?.consoleVodIdx, consoleCfg?.serviceType]);

  // consoleCfg.sessionIdx가 로드되면 ref 업데이트 (STREAM 리스너에서 stale closure 방지)
  useEffect(() => {
    sessionIdxRef.current = consoleCfg?.sessionIdx;
  }, [consoleCfg?.sessionIdx]);

  // forceStop 상태를 ref에 동기화 (onErrorCallback 스테일 클로저 방지)
  useEffect(() => {
    forceStopRef.current = forceStop;
  }, [forceStop]);

  // STREAM_OFFLINE 수신 시 forceStop=true → forceError 전파 → JWPlayer 에러이미지 표시
  // swap 판별: OFFLINE의 channelId가 직전 ONLINE의 channelId와 다르면 채널 재할당(swap) → 건너뜀
  // sessionIdx 필터: 다른 세션의 STREAM 이벤트 무시 (같은 이벤트 내 복수 세션 간 간섭 방지)
  useEffect(() => {
    const onMessage = (e) => {
      _U.parseMessage(e).then((data) => {
        if (data.code !== "SOCKET-RECEIVED") return;
        const d = data.data ? JSON.parse(data.data) : null;
        // 다른 세션의 STREAM 이벤트 무시
        if (d?.mode === "STREAM_ONLINE" || d?.mode === "STREAM_OFFLINE" ||
            d?.mode === "TEST_STREAM_ONLINE" || d?.mode === "TEST_STREAM_OFFLINE") {
          if (d.sessionIdx !== sessionIdxRef.current) return;
        }
        if (d?.mode === "STREAM_ONLINE" || d?.mode === "TEST_STREAM_ONLINE") {
          lastOnlineChannelIdRef.current = d.channelId;
          setForceStop(false);
        } else if (d?.mode === "STREAM_OFFLINE" || d?.mode === "TEST_STREAM_OFFLINE") {
          // 직전 ONLINE과 다른 채널이 OFFLINE → swap (채널 재할당) → 건너뜀
          const isSwap = lastOnlineChannelIdRef.current !== undefined &&
                         d.channelId !== lastOnlineChannelIdRef.current;
          if (!isSwap) {
            setForceStop(true);
            setIsStart(false);
            clearInterval(autuPlayInterval.current);
            autuPlayInterval.current = null;
          }
        }
      });
    };
    window.addEventListener("message", onMessage);
    return () => {
      window.removeEventListener("message", onMessage);
    };
  }, []);

  const playListKey = playList && playList[0]
    ? playList[0].file || (playList[0].sources || []).map((source) => source?.file).join("|") || "empty"
    : "none";

  return (
    <Fragment>
      <div className="video-wrap">
        <div className="video-frame">
          { playList != null && (
            <ReactJWPlayerContainer
              key={playListKey}
              eventIdx={consoleCfg?.eventIdx}
              sessionIdx={consoleCfg?.sessionIdx}
              siteInfo={siteInfo}
              playlist={playList}
              forceError={!hasValidUrl || forceStop}
              onMetaCallback={onMetaCallback}
              onPlayCallback={onPlayCallback}
              onPlayerDidMountCallback={onPlayerDidMountCallback}
              onPlayerUnMountCallback={onPlayerUnMountCallback}
              onTimeCallback={onTimeCallback}
              onPauseCallback={onPauseCallback}
              onResumeCallback={onResumeCallback}
              onErrorCallback={onErrorCallback}
              onSeekCallback={onSeekCallback}
              onCompleteCallback={onCompleteCallback}
              onReadyCallback={onReadyCallback}
              showSurveyButton={showSurveyButton}
              onSurveyButtonClick={handleCssFullscreenSurveyClick}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};
